import type { ReactElement, SVGAttributes } from 'react';
import { twMerge } from 'cn';

/** `<Success>` icon. */
export const Success = ({ className, ...props }: SVGAttributes<SVGSVGElement>): ReactElement => (
  <svg className={twMerge('h-[104px] w-[104px]', className)} viewBox='0 0 104 104' {...props}>
    <circle className='fill-success' cx='52' cy='52' r='52' />
    <path
      className='fill-light'
      d='M43.667 62.0749L32.825 51.2329L29.133 54.8989L43.667 69.4329L74.867 38.2329L71.201 34.5669L43.667 62.0749Z'
    />
  </svg>
);
